<template>
  <div class="row">
    <div class="col-12">
      <h1>{{ quiz.start_title }}</h1>
      <HMCustomContent
        class="mt-3 subtext"
        v-if="quiz.start_description"
        :json="quiz.start_description"
      />
      <HMButton
        @click="$emit('start')"
        color="brand"
        class="mt-4"
        :loading="loading"
        :disabled="disabled"
      >
        {{ quiz.start_button || $t('QUIZZES.BUTTON.BEGIN_QUIZ') }}
      </HMButton>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    quiz: {
      required: true,
      type: Object as () => StudentSolvedQuizResponse | SimpleQuizResponse,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.subtext {
  color: $dark-gray;
}
</style>
